import * as z from "zod";
import { serviceInvoiceStatus } from "./get-current-marketing-email-invoice";

export const getCurrentMarketingSmsInvoice = {
  name: "getCurrentMarketingSmsInvoice" as const,
  input: z.null(),
  output: serviceInvoiceStatus.nullable(),
};
